import {
  getTokenFromCookie,
  getTokenFromLocalStorage,
} from '~/plugins/util/auth'

export default function({ store, req }) {
  // If nuxt generate, pass this middleware
  const isServer = process.server
  if (isServer && !req) return
  const token = isServer ? getTokenFromCookie(req) : getTokenFromLocalStorage()
  store.dispatch('auth/authenticate', token)
}
